import React from "react";
import styled from "styled-components";
import { Stack } from "@mui/material";
import FileWrapper, { useFileContext } from "../context/FileWrapper";
import FilesList from "../documents/FilesList";
import Dropzone from "../forms/Dropzone";
import Button from "../shared/Button";
import ErrorUpload from "../documents/ErrorUpload";
import SuccessUpload from "../documents/SuccessUpload";

const UploadDocuments = ({ estateId }) => {
  const { submit, clearAll, displayMsg, closeMsg, isError, isLoading } =
    useFileContext();
  return (
    <StyleWrapper>
      <div
        className={`upload-doc__main ${
          displayMsg ? "d-none" : "d-flex flex-column flex-grow-1"
        }`}
      >
        <Dropzone />
        <FilesList isModalView estateId={estateId} />
        <Stack flexDirection="row" justifyContent="center" gap={2} mt={3}>
          <Button onClick={clearAll} disabled={isLoading}>
            Annuler
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={submit}
            disabled={isLoading}
          >
            Confirmer
          </Button>
        </Stack>
      </div>
      {displayMsg &&
        (isError ? <ErrorUpload handleClose={closeMsg}/> : <SuccessUpload handleClose={closeMsg} />)}
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  &.upload-doc {
    height: 100%;
    gap: 40px;
    padding: 10px;
  }

  .upload-doc__main {
    background-color: #f9f9fa;
    padding: 30px;
    border-radius: 20px;
  }

  .upload-doc__action {
    gap: 15px;

    button img {
      margin-right: 5px;
    }
  }
`;

export default (props) => (
  <FileWrapper estateId={props.estateId}>
    <UploadDocuments {...props} />
  </FileWrapper>
);
